import { colors, Typography } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

import { ListFooterContainer } from './tickets-list.styled';

export const ListFooter = ({ hasNextPage, loadMore }: { hasNextPage: boolean; loadMore: () => void }): ReactElement => (
  <ListFooterContainer paddingX={1} paddingY={1}>
    {hasNextPage ? (
      <Typography as="button" onClick={loadMore} color={colors.gray[600]} fontSize="sm" fontWeight="medium">
        Click to Load More Tickets
      </Typography>
    ) : (
      <Typography as="div" color={colors.gray[300]} fontSize="sm" fontWeight="medium">
        End Of Tickets List
      </Typography>
    )}
  </ListFooterContainer>
);
